import { useTranslate } from "@similarweb/i18n-provider";

import useHsEnrichmentJobsQuery from "app/pages/sales-intelligence/modules/crm-enrichment/impl/hubspot/queries/useHsEnrichmentJobsQuery";
import {
    MANAGEMENT_EXCLUSION_INFO_OFF,
    MANAGEMENT_EXCLUSION_INFO_ON,
} from "app/pages/sales-intelligence/pages/management/translations/managementKeys";

const EnrichmentHSStatus = (): React.ReactNode => {
    const { translate } = useTranslate();
    const { data } = useHsEnrichmentJobsQuery();

    const isOn = data && data.some((job) => job.active);

    return translate(isOn ? MANAGEMENT_EXCLUSION_INFO_ON : MANAGEMENT_EXCLUSION_INFO_OFF);
};

export default EnrichmentHSStatus;
